import React from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import style from "../../assets/css/components/Form/Form.module.css";

import { Formik, Form } from "formik";
import Button from "../Button/Button";

import Input from "../Input/Input";
import classNames from "classnames";

import { socket } from "../../config/socket";
import { NumDayInitialState, NumDayValidationSchema } from "../../utils/updateNumDay";
const MySwal = withReactContent(Swal);

function FormUpdateNumDay({idTournament}) {
  const handleSubmit = async (values) => {
    const { currentDay } = values;

    socket.emit("numCurrentDay", { currentDay, idTournament }, (res) => {
      MySwal.fire("Actualizado Exitosamente");
    });
  };

  return (
    <Formik
      initialValues={NumDayInitialState}
      validationSchema={NumDayValidationSchema}
      onSubmit={handleSubmit}
    >
      <Form className={style.form}>
        <Input name="currentDay" title="Número de jornada" type="number" />
        <div
          className={classNames(style.contButton, style.alignCenter)
          }
        >
          <Button text="Guardar" />
        </div>
      </Form>
    </Formik>
  );
}

export default FormUpdateNumDay;
